module.exports = __webpack_public_path__ + "static/media/circle-x-icon.e3053754.svg";